import { FunctionComponent } from 'react';
import 'office-ui-fabric-core/dist/css/fabric.min.css'
import { bwjLargeSpacingClass, bwjMediumSpacingClass, bwjSmallSpacingClass, msGridRowClass, Spacing, useLayoutStyles } from './styles';

export interface IBwjRowProps {
  bottomSpacing?: Spacing;
}

export const Row: FunctionComponent<IBwjRowProps> = (props) => {
  const styles = useLayoutStyles();
  const cls = [styles.row, msGridRowClass];

  let bs = props.bottomSpacing ?? Spacing.None;
  switch(bs) {
      case Spacing.XSmall:
      case Spacing.Small:
      cls.push(bwjSmallSpacingClass);
      break;
      case Spacing.Medium:
      cls.push(bwjMediumSpacingClass);
      break;
      case Spacing.Large:
      case Spacing.XLarge:
      cls.push(bwjLargeSpacingClass);
      break;
  }

  return (
    <div className={cls.join(' ')}>
        {props.children}
    </div>
  );
};